import { render, staticRenderFns } from "./getLiquorSaleOrderList.vue?vue&type=template&id=b0260a88&scoped=true&"
import script from "./getLiquorSaleOrderList.vue?vue&type=script&lang=js&"
export * from "./getLiquorSaleOrderList.vue?vue&type=script&lang=js&"
import style0 from "./getLiquorSaleOrderList.vue?vue&type=style&index=0&id=b0260a88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0260a88",
  null
  
)

export default component.exports